import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import TextInput from '../form/TextInput'; //eslint-disable-line import/no-named-as-default
import EmailInput from '../form/EmailInput';//eslint-disable-line import/no-named-as-default
import * as initActions from '../../actions/initActions';
import * as trackingDataActions from '../../actions/trackingDataActions';
import * as dialogPopupActions from '../../actions/dialogPopupActions';
import * as formValidationHelper from '../../helpers/formValidationHelper';
import * as appHelper from '../../helpers/appHelper';
import * as keyboardConstants from '../../constants/keyboardConstants';
import * as localStorage from '../../localStorage/localStorage';

class ActorPrompt extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            trackingData: this.props.trackingData,
            formParams: {
                name: "",
                email_address: ""
            },
            actor: {},
            errors: {
                name: "",
                email_address: ""
            },
            checkFormCanBeSubmitted: false,
            canSubmit: false,
            processing: false,
            checkActor: false,
            actor_prompt_instruction: appHelper.getLocaleString("actor_prompt_instruction"),
            name_label: appHelper.getLocaleString("name_label"),
            email_address_label: appHelper.getLocaleString("email_address_label"),
            please_wait_label: appHelper.getLocaleString("please_wait_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            continue_as_guest_label: appHelper.getLocaleString("continue_as_guest_label"),
        };
        this.updateFormState = this.updateFormState.bind(this);
        this.checkFormCanBeSubmitted = this.checkFormCanBeSubmitted.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.onContinue = this.onContinue.bind(this);
        this.checkActorDefined = this.checkActorDefined.bind(this);
        this.continueAsGuess = this.continueAsGuess.bind(this);
        this.setCookie = this.setCookie.bind(this);
        this.getCookie = this.getCookie.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.trackingData !== nextProps.trackingData){
            this.setState({
                trackingData: Object.assign({},nextProps.trackingData),
                checkActor: true
            });
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                actor_prompt_instruction: appHelper.getLocaleString("actor_prompt_instruction"),
                name_label: appHelper.getLocaleString("name_label"),
                email_address_label: appHelper.getLocaleString("email_address_label"),
                please_wait_label: appHelper.getLocaleString("please_wait_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
                continue_as_guest_label: appHelper.getLocaleString("continue_as_guest_label"),
            });
        }
    }

    componentDidUpdate() {
        if (this.state.checkFormCanBeSubmitted) {
            this.checkFormCanBeSubmitted();
        }

        if(this.state.checkActor){
            this.checkActorDefined();
        }
    }

    updateFormState(event) {
        const field = event.target.name;
        let formParams = this.state.formParams;
        formParams[field] = event.target.value;
        this.setState({
            formParams: formParams,
            checkFormCanBeSubmitted: true
        });
    }


    checkFormCanBeSubmitted() {

        this.setState({checkFormCanBeSubmitted: false});
        let canSubmit = true;

        let nameValid = formValidationHelper.validateLength(this.state.formParams.name);
        let emailValid = formValidationHelper.validateLength(this.state.formParams.email_address);

        if (!nameValid.result) {
            canSubmit = false;
        }

        if (!emailValid.result) {
            canSubmit = false;
        }

        this.setState({canSubmit: canSubmit});
    }

    validateForm() {

        this.setState({checkFormCanBeSubmitted: false});
        let formIsValid = true;
        let errors = {};

        let nameValid = formValidationHelper.validateLength(this.state.formParams.name);
        let emailValid = formValidationHelper.validateEmail(this.state.formParams.email_address);

        if (!nameValid.result) {
            errors.name = 'Name ' + nameValid.message;
            formIsValid = false;
        }

        if (!emailValid.result) {
            errors.email_address = emailValid.message;
            formIsValid = false;
        }

        this.setState({
            errors: errors
        });

        return formIsValid;
    }

    onContinue(event) {
        event.preventDefault();

        if (!this.validateForm()) {
            return;
        }

        this.setState({processing: true});

        let actor = {
            objectType: "Agent",
            name: this.state.formParams.name,
            mbox: `mailto:${this.state.formParams.email_address}`
        };
       // this.context.router.push(`/?actor=${encodeURI(JSON.stringify(actorObject))}`);
        this.props.actions.setActorDetails(actor);
    }

    checkActorDefined(){
        this.setState({checkActor: false});
        if(appHelper.isDefined(this.state.trackingData.actor)){
            this.props.actions.initTracking(this.props.contentData);
        }
    }

    continueAsGuess(){
        let cookieName = "actor";
        let actor = {};
        let actorCookie = this.getCookie(cookieName);
        //let actorCookie = "";
        let formParams = this.state.formParams;

        formParams['name'] = `Guest`;

        this.setState({
            formParams: formParams,
            processing: true,
        });

        if(actorCookie === ""){
            let d = new Date();
            let n = d.getTime();
            let email_address = `${String(n)}@guest.com`;
            let name = `Guest ${String(n)}`;

            actor = {
                objectType: "Agent",
                name: name,
                mbox: `mailto:${email_address}`
            };

            this.setCookie(cookieName, JSON.stringify(actor), 2);

            this.props.actions.setActorDetails(actor);
        }else{
            actor = JSON.parse(actorCookie);
            this.props.actions.setActorDetails(actor);
        }


    }

    setCookie(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }


    getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.continueAsGuess();
        }
    }

    render() {
        return (
            <div className="init-prompt-content">
                {
                    !this.state.processing
                    ?
                        <div>
                            <div dangerouslySetInnerHTML={{__html: this.state.actor_prompt_instruction}}/>
                            <form>

                                <div className="row">
                                    <div className="col-xs-12">
                                        <TextInput
                                            name="name"
                                            label={`${this.state.name_label}`}
                                            className=""
                                            value={this.state.formParams.name}
                                            onChange={this.updateFormState}
                                            error={this.state.errors.name}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <EmailInput
                                            name="email_address"
                                            label={`${this.state.email_address_label}`}
                                            className=""
                                            value={this.state.formParams.email_address}
                                            onChange={this.updateFormState}
                                            error={this.state.errors.email_address}
                                        />
                                    </div>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <input
                                        type="submit"
                                        disabled={!this.state.canSubmit || this.state.processing}
                                        value={this.state.processing ? `${this.state.please_wait_label}` : `${this.state.continue_label}`}
                                        className="btn btn-lg guroo-btn"
                                        onClick={this.onContinue}
                                    />
                                </div>
                                <br/>
                                {appHelper.isDefined(localStorage.contentData.experience.include_continue_as_guest) && localStorage.contentData.experience.include_continue_as_guest
                                    ?<div className="text-center">
                                        <div onClick={this.continueAsGuess} className="guroo-active-link" role="button" tabIndex="0" onKeyDown={this.setKeyboardAccessibility} dangerouslySetInnerHTML={{__html: this.state.continue_as_guest_label}}/>
                                    </div>
                                    :null
                                }



                            </form>
                        </div>
                    :
                        <div className="text-center">
                            <p>Thanks {this.state.formParams.name},</p>
                            <p>One moment please.</p>
                            <br/>
                            <div className="preloader-image-container">
                                <img src={require(`../../assets/images/preloader/gurooLoading.gif`)} alt=""/>
                            </div>
                        </div>

                }

            </div>
        );
    }
}

ActorPrompt.propTypes = {
    initData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ActorPrompt.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        initData: state.initData,
        contentData: state.contentData,
        trackingData: state.trackingData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, initActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActorPrompt);



/** WEBPACK FOOTER **
 ** ./src/components/initialisation/ActorPrompt.js
 **/